import { useState } from "react";
import { Box, Collapse, IconButton, Typography } from "@mui/material";
import { ExpandMore as ExpandMoreIcon } from "@mui/icons-material";
import { INITIATIVE_FIELDS } from "../domain/initiativeFields";
import { formatFieldValue } from "../utils/formatFieldValue";

const SNAPSHOT_FIELDS = Object.keys(INITIATIVE_FIELDS).filter(
  (field) => field !== "title" && field !== "archived",
);

export default function DeletionSnapshot({ reason, snapshot }) {
  const [expanded, setExpanded] = useState(false);

  const styles = {
    toggleRow: {
      display: "flex",
      alignItems: "center",
      gap: 0.5,
      cursor: "pointer",
    },
    expandIcon: (expanded) => ({
      transform: expanded ? "rotate(180deg)" : "rotate(0deg)",
      transition: "transform 0.2s",
      p: 0,
    }),
    details: { mt: 0.5, display: "flex", flexDirection: "column", gap: 0.25 },
    fieldLabel: { fontWeight: 700 },
    fieldValue: { color: "background.textMuted" },
  };

  return (
    <Box>
      <Box sx={styles.toggleRow} onClick={() => setExpanded((prev) => !prev)}>
        <Typography variant="body2">{reason}</Typography>
        <IconButton size="small" sx={styles.expandIcon(expanded)}>
          <ExpandMoreIcon fontSize="small" />
        </IconButton>
      </Box>
      <Collapse in={expanded}>
        <Box sx={styles.details}>
          {SNAPSHOT_FIELDS.map((field) => (
            <Typography key={field} variant="body2" sx={styles.fieldValue}>
              <Box component="span" sx={styles.fieldLabel}>
                {INITIATIVE_FIELDS[field].label}:
              </Box>{" "}
              {formatFieldValue(snapshot[field])}
            </Typography>
          ))}
        </Box>
      </Collapse>
    </Box>
  );
}
